/* eslint-disable @typescript-eslint/no-explicit-any */
/* eslint-disable @typescript-eslint/no-non-null-assertion */
import React, { useEffect, useState } from 'react';
import { LayoutBase } from '../../layouts';
import { ToolsDetails, UserForm } from '../../components/custom';
import { Box, Divider, LinearProgress, SelectChangeEvent, Typography } from '@mui/material';
import { IUser, UserServices, NivelAcesso, SubNivelAcesso, PermissaoTipo } from '../../services/api/users/UserServices';
import { useNavigate, useParams } from 'react-router-dom';
import { useAuthContext } from '../../context';
import { ConfirmationDialog, CustomAlert } from '../../components/shared';
import { DamsServices, IDamsList } from '../../services/api/dams/DamServices';

export const DetailsUser = () => {
    const { id } = useParams();

    const [data, setData] = useState<IUser>({
        email: '',
        login: '',
        nome: '',
        permissoes: 'add,edit,remove',
        ativo: true,
        notificacao: false,
        nivel: 'user',
        main_user: false,
        register: '',
        role: '',
        mobile_phone: '',
        senha: '',
        sector: '',
        ramal: '',
        foto: '',
        outsystem: false,
        nivel_acesso: {
            informacoes: {
                central: '',
                identificacao: '',
                caracterizacao: '',
                organograma: '',
            },
            documentacao_tecnica: {
                caracteristicas: '',
                arquivos: '',
            },
            registros: {
                RISR: '',
                RISROT: '',
                RISE: '',
                operacoes: '',
                monitoramento: '',
            },
            acompanhamentos: {
                comunicacao: '',
                visualizacao: '',
                inspecoes: '',
                anomalias: '',
                plano: '',
            },
            revisao: {
                RPSB: '',
            },
            PAE: {
                PAE: '',
                conformidades: '',
                treinamento: '',
                seminario: '',
                simulado: '',
                registro: '',
            },
            notificacao: {
                leitura: '',
                novo_risrot: '',
                nova_anomalia: '',
                inicio_atividade: '',
                novo_plano_acao: '',
                status_plano: '',
                status_tarefa: '',
                nova_tarefa: '',
                novo_topico: '',
            }
        },
        barragens_visiveis: '',
    });
    const [loadin, setLoadin] = useState<boolean>(false);
    const [error, setError] = useState<boolean>(false);
    const { userData } = useAuthContext();
    const navigate = useNavigate();
    const [alertInfo, setAlertInfo] = useState<{ open: boolean; message: string; severity: 'success' | 'error' | 'warning' | 'info', key: string }>({
        open: false,
        message: '',
        severity: 'success',
        key: ''
    });
    const [dialogOpen, setDialogOpen] = useState(false);
    const [passwordError, setPasswordError] = useState<boolean>(false);
    const [sendClick, setSendClick] = useState<boolean>(false);
    const [isNivelAcessoModalOpen, setIsNivelAcessoModalOpen] = useState<boolean>(false);
    const [dams, setDams] = useState<null | IDamsList[]>(null);


    async function fetchDam() {
        try {
            const r = await DamsServices.get(userData.id_empresa ?? '');
            if (r instanceof Error) {
                setAlertInfo({
                    message: 'Erro ao buscar dados',
                    open: true,
                    severity: 'error',
                    key: new Date().toString()
                });
                return;
            } else {
                setDams(r as IDamsList[]);
            }
        } catch (error) {
            setAlertInfo({
                message: 'Erro ao buscar dados',
                open: true,
                severity: 'error',
                key: new Date().toString()
            });
        }
    }

    useEffect(() => {
        setLoadin(true);
        fetchData();
        fetchDam();
    }, [id]);

    function verify(data: IUser): boolean {
        const isValid = (
            data.email !== '' &&
            data.login !== '' &&
            data.nome !== ''
        );
        return isValid;
    }

    const fetchData = () => {
        if (id && id !== 'novo') {
            UserServices.getById(id)
                .then((result) => {
                    if (result instanceof Error) {
                        setLoadin(false);
                        setError(true);
                        setAlertInfo({ message: `Erro ao buscar usuário: ${result.message}`, open: true, severity: 'error', key: new Date().toString() });
                    } else {
                        setLoadin(false);
                        setData({
                            ...result,
                            nivel_acesso: result.nivel_acesso || {
                                informacoes: {},
                                documentacao_tecnica: {},
                                registros: {},
                                acompanhamentos: {},
                                revisao: {},
                                PAE: {},
                            },
                            barragens_visiveis: typeof result.barragens_visiveis === 'string' ? result.barragens_visiveis.split(',').map(s => s.trim()) : result.barragens_visiveis || [],
                        });
                        setError(false);
                    }
                })
                .catch(err => {
                    setLoadin(false);
                    setError(true);
                    setAlertInfo({ message: `Erro inesperado ao buscar: ${err.message || 'Verifique sua conexão.'}`, open: true, severity: 'error', key: new Date().toString() });
                });
        } else {
            setLoadin(false);
            setData({
                email: '',
                login: '',
                nome: '',
                permissoes: '',
                ativo: true,
                notificacao: false,
                nivel: 'user',
                main_user: false,
                register: '',
                role: '',
                mobile_phone: '',
                senha: '',
                sector: '',
                ramal: '',
                foto: '',
                outsystem: false,
                nivel_acesso: {
                    informacoes: {
                        central: '',
                        identificacao: '',
                        caracterizacao: '',
                        organograma: '',
                    },
                    documentacao_tecnica: {
                        caracteristicas: '',
                        arquivos: '',
                    },
                    registros: {
                        RISR: '',
                        RISROT: '',
                        RISE: '',
                        operacoes: '',
                        monitoramento: '',
                    },
                    acompanhamentos: {
                        comunicacao: '',
                        visualizacao: '',
                        inspecoes: '',
                        anomalias: '',
                        plano: '',
                    },
                    revisao: {
                        RPSB: '',
                    },
                    PAE: {
                        PAE: '',
                        conformidades: '',
                        treinamento: '',
                        seminario: '',
                        simulado: '',
                        registro: '',
                    },
                    notificacao: {
                        leitura: '',
                        novo_risrot: '',
                        nova_anomalia: '',
                        inicio_atividade: '',
                        novo_plano_acao: '',
                        status_plano: '',
                        status_tarefa: '',
                        nova_tarefa: '',
                        novo_topico: '',
                    }
                },
                barragens_visiveis: '',
            });
            setError(false);
        }
    };

    const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
        setPasswordError(false);
        const { name, type, checked, value } = e.target;
        const updatedValue = type === 'checkbox' ? checked : value;

        if (name === 'ativo') {
            setData(prevData => ({
                ...prevData,
                ativo: checked
            }));
            return;
        }

        const updatedData = { ...data, [name]: updatedValue };
        setData(updatedData);
    };

    const hanldePermissionChange = (newValue: string) => {
        setData(prevData => ({
            ...prevData,
            permissoes: newValue
        }));
    };

    const handleOutsystemUserChange = (outsystem: boolean) => {
        setData(prevData => ({
            ...prevData,
            outsystem: outsystem,
            senha: outsystem ? '' : prevData.senha
        }));
    };

    type PermissaoAtualizacao = PermissaoTipo | 'toggle';

    const handleNivelAcessoChange = (
        categoria: keyof NivelAcesso,
        subCategoria: keyof SubNivelAcesso,
        permission: PermissaoAtualizacao,
        isChecked: boolean
    ) => {
        setData(prevData => {
            // exceção para notificacao
            if (categoria === 'notificacao') {
                return {
                    ...prevData,
                    nivel_acesso: {
                        ...prevData.nivel_acesso,
                        [categoria]: {
                            ...prevData.nivel_acesso?.[categoria],
                            [subCategoria]: String(isChecked),
                        },
                    },
                };
            }

            const currentSubCategoriaPermissions =
                prevData.nivel_acesso?.[categoria]?.[subCategoria] || '';

            let updatedPermissionsArray = currentSubCategoriaPermissions
                .split(',')
                .filter(p => p !== '');

            if (isChecked) {
                if (!updatedPermissionsArray.includes(permission)) {
                    updatedPermissionsArray.push(permission);
                }
            } else {
                updatedPermissionsArray = updatedPermissionsArray.filter(
                    p => p !== permission
                );
            }

            const orderedPermissions = ['add', 'edit', 'remove', 'view'].filter(p =>
                updatedPermissionsArray.includes(p)
            );

            return {
                ...prevData,
                nivel_acesso: {
                    ...prevData.nivel_acesso,
                    [categoria]: {
                        ...prevData.nivel_acesso?.[categoria],
                        [subCategoria]: orderedPermissions.join(','),
                    },
                },
            };
        });
    };

    const handleSave = async () => {
        if (sendClick) {
            return;
        }

        setSendClick(true);
        setAlertInfo({ message: '', open: false, severity: 'error', key: new Date().toString() });

        const valid = verify(data);
        setError(!valid);

        if (!valid) {
            setAlertInfo({ message: 'Por favor, preencha todos os campos obrigatórios.', open: true, severity: 'warning', key: new Date().toString() });
            setSendClick(false);
            return;
        }

        const dataToSend: Partial<IUser> = { ...data };

        if (id === 'novo' && data.outsystem) {
            dataToSend.senha = '';
        }

        else if (id !== 'novo' && dataToSend.senha === '') {
            delete dataToSend.senha;
        }

        if (Array.isArray(dataToSend.barragens_visiveis) && dataToSend.barragens_visiveis.length > 0) {
            dataToSend.barragens_visiveis = dataToSend.barragens_visiveis.join(',');
        }

        if (Array.isArray(dataToSend.barragens_visiveis) && dataToSend.barragens_visiveis.length === 0) {
            dataToSend.barragens_visiveis = '';
        }

        if (dataToSend.nivel_acesso && dataToSend.nivel_acesso.acompanhamentos) {
            if ((dataToSend.nivel_acesso.acompanhamentos as any).PAE !== undefined && dataToSend.nivel_acesso.acompanhamentos.plano === undefined) {
                dataToSend.nivel_acesso.acompanhamentos.plano = (dataToSend.nivel_acesso.acompanhamentos as any).PAE;
            }
            delete (dataToSend.nivel_acesso.acompanhamentos as any).PAE;
        }

        if (id === 'novo') {
            if (userData.id_empresa) {
                dataToSend.id_empresa = userData.id_empresa;
            } else if (!dataToSend.id_empresa) {
                setAlertInfo({ message: 'Por favor, selecione a empresa para o novo usuário.', open: true, severity: 'warning', key: new Date().toString() });
                setSendClick(false);
                return;
            }
            dataToSend.ativo = true;

            try {
                const response = await UserServices.create(dataToSend.id_empresa!, dataToSend as IUser);
                if (response instanceof Error) {
                    setAlertInfo({ message: `Erro ao salvar! Erro: ${response.message}`, open: true, severity: 'error', key: new Date().toString() });
                } else {
                    setAlertInfo({ message: 'Registro salvo', open: true, severity: 'success', key: new Date().toString() });
                    setTimeout(() => {
                        navigate('/users');
                    }, 1000);
                }
            } catch (errorApi) {
                setAlertInfo({ message: `Erro inesperado ao salvar! ${errorApi instanceof Error ? errorApi.message : 'Verifique sua conexão.'}`, open: true, severity: 'error', key: new Date().toString() });
            } finally {
                setSendClick(false);
            }
        } else {
            try {
                const response = await UserServices.upgrade(id!, dataToSend as IUser);
                if (response instanceof Error) {
                    setAlertInfo({ message: `Erro ao atualizar! Erro: ${response.message}`, open: true, severity: 'error', key: new Date().toString() });
                } else {
                    setAlertInfo({ message: 'Registro atualizado', open: true, severity: 'success', key: new Date().toString() });
                    setTimeout(() => {
                        navigate('/users');
                    }, 1000);
                }
            } catch (errorApi) {
                setAlertInfo({ message: `Erro inesperado ao atualizar! ${errorApi instanceof Error ? errorApi.message : 'Verifique sua conexão.'}`, open: true, severity: 'error', key: new Date().toString() });
            } finally {
                setSendClick(false);
            }
        }
    };

    const handleNew = () => {
        navigate('/users/detalhes/novo');
    };

    const handleDialog = () => {
        setDialogOpen(!dialogOpen);
    };

    const handleDelet = () => {
        if (userData.permissoes.includes('remove')) {
            if (id && id !== 'novo') {
                UserServices.deleteById(id)
                    .then((response) => {
                        if (response instanceof Error) {
                            setAlertInfo({ message: `Erro ao deletar! Erro: ${response.message}`, open: true, severity: 'error', key: new Date().toString() });
                        } else {
                            setDialogOpen(false);
                            setAlertInfo({ message: 'Registro deletado', open: true, severity: 'success', key: new Date().toString() });
                            setTimeout(() => {
                                navigate('/users');
                            }, 1000);
                        }
                    })
                    .catch((error) => {
                        setAlertInfo({ message: `Erro inesperado ao deletar! ${error.message || 'Verifique sua conexão.'}`, open: true, severity: 'error', key: new Date().toString() });
                    });
            } else {
                setAlertInfo({ message: 'Não é possível deletar um usuário sem ID ou em modo de criação.', open: true, severity: 'warning', key: new Date().toString() });
            }
        } else {
            setAlertInfo({ message: 'Sem permissão para a ação', open: true, severity: 'error', key: new Date().toString() });
        }
    };

    const handleChangeSelect = (event: SelectChangeEvent) => {
        setData(prevData => ({
            ...prevData,
            id_empresa: event.target.value as string
        }));
    };

    // const handleChangeBarragem = (event: SelectChangeEvent<string[]>) => {
    //     const value = event.target.value;
    //     setData({
    //         ...data,
    //         barragens_visiveis: typeof value === 'string' ? value.split(',') : value
    //     });
    // };

    const handleChangeBarragem = (event: SelectChangeEvent<string[]>) => {
        const value = event.target.value;

        const rawArray = typeof value === 'string' ? value.split(',') : value;

        const cleanArray = rawArray.map(uuid => uuid.replace(/[{}]/g, '').trim());

        const finalArray = cleanArray.filter(uuid => uuid.length > 0);

        setData({
            ...data,
            barragens_visiveis: finalArray
        });
    };

    return (
        <LayoutBase
            tollBar={<ToolsDetails
                showSaveButton={userData.permissoes.includes('add') || userData.permissoes.includes('edit')}
                showDeletButton={userData.permissoes.includes('remove') && id !== 'novo'}
                showNewButton={userData.permissoes.includes('add')}
                showBackButton={true}
                onClickSave={handleSave}
                onClickDelet={handleDialog}
                onClickNew={handleNew}
                disableSave={sendClick}
            />}
            title='Usuário'
        >
            <Box>
                {loadin ? (
                    <>
                        <LinearProgress />
                        <Typography variant="body2" sx={{ mt: 2, textAlign: 'center' }}>Carregando dados do usuário...</Typography>
                    </>
                ) : (
                    <>
                        <Box padding={1} marginBottom={1}>
                            <Typography variant='h6'>Ficha de usuários</Typography>
                            <Divider />
                        </Box>
                        <Box>
                            <UserForm
                                data={data}
                                handleChange={handleChange}
                                handlePermission={hanldePermissionChange}
                                error={error}
                                handleChangeSelect={handleChangeSelect}
                                passwordError={passwordError}
                                handleOutsystemUserChange={handleOutsystemUserChange}
                                handleNivelAcessoChange={handleNivelAcessoChange}
                                isNivelAcessoModalOpen={isNivelAcessoModalOpen}
                                onCloseNivelAcessoModal={() => setIsNivelAcessoModalOpen(false)}
                                onOpenNivelAcessoModal={() => setIsNivelAcessoModalOpen(true)}
                                isEmpresa={userData.nivel === 'empresa' ? true : false}
                                listDam={dams}
                                handleChangeBarragem={handleChangeBarragem}
                                isMainUser={data.main_user ?? false}
                            />
                        </Box>
                    </>
                )}
                {alertInfo.open &&
                    <CustomAlert
                        severity={alertInfo.severity}
                        message={alertInfo.message}
                    />
                }
                <ConfirmationDialog
                    isOpen={dialogOpen}
                    onClose={handleDialog}
                    onConfirm={handleDelet}
                    title="Confirmação de Exclusão"
                    message="Tem certeza que deseja excluir?"
                />
            </Box>
        </LayoutBase>
    );
};